export const Books = [
    {
        type: "Books",
        name: "⭐️ Why We Love Dogs, Eat Pigs, and Wear Cows",
        category: "",
        author: "Melanie Joy",
        description: "",
        link: "https://www.amazon.com/Love-Dogs-Pigs-Wear-Cows/dp/1573245054/",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Equality",
        category: "",
        author: "Joan Dunayer",
        description: "",
        link: "http://www.amazon.com/Animal-Equality-Liberation-Joan-Dunayer/dp/0970647557/ref=sr_1_1?ie=UTF8&qid=1430720484&sr=8-1&keywords=Animal+Equality%3A+Language+and+Liberation",
        "": "",
    },
    {
        type: "Books",
        name: "Ethics Into Action: Henry Spira and the Animal Rights Movement",
        category: "",
        author: "Peter Singer",
        description: "",
        link: "https://www.amazon.com/Ethics-Into-Action-Animal-Movement/dp/0847697533",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Liberation",
        category: "",
        author: "Peter Singer",
        description: "",
        link: "https://www.amazon.com/Animal-Liberation-Definitive-Classic-Movement/dp/B017JBUOXK/ref=sr_1_1?keywords=Animal+Liberation+Peter+Singer&qid=1561908379&s=audible&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "How Not To Die",
        category: "",
        author: "Michael Greger",
        description: "",
        link: "https://www.amazon.com/How-Not-Die-Discover-Scientifically/dp/B016CME5B4/ref=sr_1_1?keywords=How+Not+To+Die+Michael+Greger&qid=1561908398&s=audible&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Animal Activist's Handbook",
        category: "",
        author: "Matt Ball and Brice Friedrich",
        description: "",
        link: "https://www.amazon.com/Animal-Activists-Handbook-Maximizing-Positive/dp/B072W8QXFZ/ref=sr_1_1?keywords=The+Animal+Activist%27s+Handbook&qid=1561908363&s=audible&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Bleating Hearts",
        category: "",
        author: "Mark Hawthorne",
        description: "",
        link: "http://www.amazon.com/Bleating-Hearts-Hidden-Animal-Suffering/dp/1780998511",
        "": "",
    },
    {
        type: "Books",
        name: "Eating Animals",
        category: "",
        author: "Jonathan Safran Foer",
        description: "",
        link: "http://www.amazon.com/Eating-Animals-Jonathan-Safran-Foer/dp/0316069884/ref=sr_1_1?s=books&ie=UTF8&qid=1430719165&sr=1-1&keywords=eating+animals",
        "": "",
    },
    {
        type: "Books",
        name: "Farm Sanctuary",
        category: "",
        author: "Gene Baur",
        description: "",
        link: "http://www.amazon.com/Farm-Sanctuary-Changing-Hearts-Animals/dp/B002SB8QAU/ref=sr_1_1?ie=UTF8&qid=1369941473&sr=8-1&keywords=farm+sanctuary",
        "": "",
    },
    {
        type: "Books",
        name: "Veganomics",
        category: "",
        author: "Nick Cooney",
        description: "",
        link: "http://www.amazon.com/Veganomics-Surprising-Motivates-Vegetarians-Breakfast-ebook/dp/B00EVYZNVW",
        "": "",
    },
    {
        type: "Books",
        name: "Green is the New Red",
        category: "",
        author: "Will Potter",
        description: "",
        link: "http://www.amazon.com/Green-New-Red-Insiders-Movement/dp/087286538X",
        "": "",
    },
    {
        type: "Books",
        name: "Every Twelve Seconds: Industrialized Slaughter and the Politics of Sight",
        category: "",
        author: "Timothy Pachirat",
        description: "",
        link: "https://www.amazon.com/Every-Twelve-Seconds-Industrialized-Slaughter/dp/0300152671",
        "": "",
    },
    {
        type: "Books",
        name: "Mercy For Animals",
        category: "",
        author: "Nathan Runkle",
        description: "",
        link: "https://mercyforanimals.org/book/",
        "": "",
    },
    {
        type: "Books",
        name: "Not As Nature",
        category: "",
        author: "Rich Hardy",
        description: "",
        link: "https://www.bookdepository.com/Not-Nature-Intended-Rich-Hardy/9781789650631",
        "": "",
    },
    {
        type: "Books",
        name: "Changing the Game: Animal Liberation in the Twenty-First Century",
        category: "",
        author: "Norm Phelps",
        description: "",
        link: "https://www.amazon.com/Changing-Game-Liberation-Twenty-First-Century/dp/1590564839",
        "": "",
    },
    {
        type: "Books",
        name: "30 Non-Vegan Excuses and How To Respond to Them",
        category: "",
        author: "Ed Winters",
        description: "",
        link: "https://earthlinged.org/ebook",
        "": "",
    },
    {
        type: "Books",
        name: "This Is Vegan Propaganda: (& Other Lies the Meat Industry Tells You)",
        category: "",
        author: "Ed Winters",
        description: "",
        link: "https://earthlinged.org/book",
        "": "",
    },
    {
        type: "Books",
        name: "A Boy, A Chicken and The Lion of Judah",
        category: "",
        author: "Roberta Kalechofsky",
        description: "",
        link: "https://www.amazon.com/Boy-Chicken-Lion-Judah/dp/0916288587",
        "": "",
    },
    {
        type: "Books",
        name: "A Home for Henny",
        category: "",
        author: "Karen Davis",
        description: "",
        link: "https://www.amazon.ca/Home-Henny-Karen-Davis/dp/1497326524",
        "": "",
    },
    {
        type: "Books",
        name: "A Rooster’s Tale: A Year in the Life of a Clan of Chickens",
        category: "",
        author: "Claudia Bruckert",
        description: "",
        link: "https://www.amazon.com/Roosters-Tale-Claudia-Bruckert/dp/159598206X",
        "": "",
    },
    {
        type: "Books",
        name: "A Theory of Justice for Animals: Animal Rights in a Nonideal World",
        category: "",
        author: "Robert Garner",
        description: "",
        link: "https://www.amazon.com/Theory-Justice-Animals-Animal-Nonideal/dp/0199936315/ref=sr_1_1?dchild=1&keywords=A+Theory+of+Justice+for+Animals%3A+Animal+Rights+in+a+Nonideal+World&qid=1603152504&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "A Vegan Ethic: Embracing a Life of Compassion Toward All",
        category: "",
        author: "Mark Hawthorne",
        description: "",
        link: "https://www.amazon.com/Vegan-Ethic-Embracing-Compassion-Toward/dp/1785354027/ref=sr_1_1?dchild=1&keywords=A+Vegan+Ethic%3A+Embracing+a+Life+of+Compassion+Toward+All&qid=1603152624&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Always Too Much and Never Enough:A Memoir",
        category: "",
        author: "Jasmin Singer",
        description: "",
        link: "https://www.amazon.ca/Always-Too-Much-Never-Enough/dp/042527957X",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Equality : Language and Liberation",
        category: "",
        author: "Joan Dunayer",
        description: "",
        link: "https://www.amazon.com/Animal-Equality-Liberation-Joan-Dunayer/dp/0970647557/ref=sr_1_1?dchild=1&keywords=Animal+Equality+%3A+Language+and+Liberation&qid=1603153460&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal factory : the looming threat of industrial pig, dairy, and poultry farms to humans and the environment",
        category: "",
        author: "David Kirby",
        description: "",
        link: "https://www.amazon.com/Animal-Factory-Looming-Industrial-Environment/dp/0312671741/ref=sr_1_1?dchild=1&keywords=Animal+factory+%3A+the+looming+threat+of+industrial+pig%2C+dairy%2C+and+poultry+farms+to+humans+and+the+environment&qid=1603153531&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Impact: Secrets Proven to Achieve Results and Move the World",
        category: "",
        author: "Caryn Ginsberg",
        description: "",
        link: "https://www.amazon.com/Animal-Impact-Secrets-Achieve-Results/dp/0984766073/ref=sr_1_1?dchild=1&keywords=Animal+Impact%3A+Secrets+Proven+to+Achieve+Results+and+Move+the+World&qid=1603153577&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Liberation",
        category: "",
        author: "Peter Singer",
        description: "",
        link: "https://www.amazon.com/Animal-Liberation-Definitive-Classic-Movement/dp/0061711306/ref=sr_1_1?dchild=1&keywords=Animal+Liberation&qid=1603153621&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Obligate Carnivore: Cats, Dogs, and What it Really Means to be Vegan",
        category: "",
        author: "Jed Gillen",
        description: "The book we've all been waiting for! Not only provides a definitive answer to the controversial question 'Can cats be vegan?' (they can!), but through examples, philosophical musings, and personal stories, explains why those in the ethical vegan community MUST feed their cats and dogs a vegan diet!",
        link: "https://www.amazon.com/Obligate-Carnivore-Really-Means-Vegan/dp/0974218006",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Oppression and Human Violence: Domesecration, Capitalism, and Global Conflict",
        category: "",
        author: "David A. Nibert",
        description: "",
        link: "https://www.amazon.com/Animal-Oppression-Human-Violence-Domesecration-ebook/dp/B00CP7EXP4/ref=sr_1_1?dchild=1&keywords=Animal+Oppression+and+Human+Violence%3A+Domesecration%2C+Capitalism%2C+and+Global+Conflict&qid=1603153823&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Place: Where Magical Things Happen",
        category: "",
        author: "Kim Sturla",
        description: "",
        link: "https://www.amazon.ca/Animal-Place-Magical-Things-Happen/dp/0964406209",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Rights and Human Obligations (2nd Edition)",
        category: "",
        author: "Tom Regan, Peter Singer",
        description: "",
        link: "https://www.amazon.com/Animal-Rights-Human-Obligations-2nd/dp/0130368644",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Rights, Human Wrongs: An Introduction to Moral Philosophy",
        category: "",
        author: "Tom Regan",
        description: "",
        link: "https://www.amazon.com/Animal-Rights-Human-Wrongs-Introduction-ebook/dp/B079HV326J/ref=sr_1_1?dchild=1&keywords=Animal+Rights%2C+Human+Wrongs%3A+An+Introduction+to+Moral+Philosophy&qid=1603240618&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Rights/Human Rights: Entanglements of Oppression and Liberation",
        category: "",
        author: "David A. Nibert",
        description: "",
        link: "https://www.amazon.com/Animal-Rights-Human-Entanglements-Institutions-ebook/dp/B00EGJAVRS/ref=sr_1_1?dchild=1&keywords=Animal+Rights%2FHuman+Rights%3A+Entanglements+of+Oppression+and+Liberation&qid=1603240661&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Rights: Current Debates and New Directions",
        category: "",
        author: "Cass R. Sunstein, Martha C. Nussbaum",
        description: "",
        link: "https://www.amazon.com/Animal-Rights-Current-Debates-Directions/dp/0195305108/ref=sr_1_1?dchild=1&keywords=Animal+Rights%3A+Current+Debates+and+New+Directions&qid=1603240720&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Rights: The Abolitionist Approach",
        category: "",
        author: "Gary L. Francione, Anna Charlton",
        description: "",
        link: "https://www.amazon.com/Animal-Rights-Abolitionist-Gary-Francione/dp/0996719237/ref=sr_1_1?dchild=1&keywords=Animal+Rights%3A+The+Abolitionist+Approach&qid=1603241012&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animal Wise: The Thoughts and Emotions of Our Fellow Creatures",
        category: "",
        author: "Virginia Morell",
        description: "",
        link: "https://www.amazon.com/Animal-Wise-Thoughts-Creatures-2013-02-26/dp/B01FEKDZMA/ref=sr_1_1?dchild=1&keywords=Animal+Wise%3A+The+Thoughts+and+Emotions+of+Our+Fellow+Creatures&qid=1603241056&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animals and Why They Matter",
        category: "",
        author: "Mary Midgley",
        description: "",
        link: "https://www.amazon.com/Animals-They-Matter-Mary-Midgley/dp/0820320412/ref=sr_1_1?dchild=1&keywords=Animals+and+Why+They+Matter&qid=1603241111&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animals and Women: Feminist Therotical Explorations",
        category: "",
        author: "Carol J. Adams & Josephine Donovan",
        description: "",
        link: "https://www.amazon.com/Animals-Women-Feminist-Theoretical-Explorations/dp/0822316676/ref=sr_1_1?dchild=1&keywords=animals+and+women%3A+feminist+theoretical+explorations&qid=1603241141&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animals as Persons: Essays on the Abolition of Animal Exploitation",
        category: "",
        author: "Gary L. Francione",
        description: "",
        link: "https://www.amazon.com/Animals-Persons-Essays-Abolition-Exploitation-ebook/dp/B0070YNOI4/ref=sr_1_1?dchild=1&keywords=Animals+as+Persons%3A+Essays+on+the+Abolition+of+Animal+Exploitation&qid=1603241265&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animals Matter: A Biologist Explains Why We Should Treat Animals with Compassion and Respect",
        category: "",
        author: "Marc Bekoff",
        description: "",
        link: "https://www.amazon.com/Animals-Matter-Biologist-Explains-Compassion/dp/1590305221/ref=sr_1_1?dchild=1&keywords=Animals+Matter%3A+A+Biologist+Explains+Why+We+Should+Treat+Animals+with+Compassion+and+Respect&qid=1603241378&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Animals Property & The Law (Ethics And Action)",
        category: "",
        author: "Gary Francione",
        description: "",
        link: "https://www.amazon.com/Animals-Property-Law-Ethics-Action-ebook/dp/B003NVMH04/ref=sr_1_1?dchild=1&keywords=Animals+Property+%26+The+Law+%28Ethics+And+Action%29&qid=1603241416&s=books&sr=1-11",
        "": "",
    },
    {
        type: "Books",
        name: "Animals, Men, and Morals",
        category: "",
        author: "Godlovitch and Harris",
        description: "",
        link: "https://www.amazon.com/Animals-man-morals-maltreatment-non-humans/dp/0575013443/ref=sr_1_2?dchild=1&keywords=Animals%2C+Men%2C+and+Morals&qid=1603241910&s=books&sr=1-2",
        "": "",
    },
    {
        type: "Books",
        name: "Becoming Vegan: The Complete Guide to Adopting a Healthy Plant-Based Diet",
        category: "",
        author: "Brenda Davis, Vesanto Melina",
        description: "",
        link: "https://www.amazon.com/Becoming-Vegan-Reference-Plant-Based-Comprehensive/dp/1570672970/ref=sr_1_1?dchild=1&keywords=Becoming+Vegan%3A+The+Complete+Guide+to+Adopting+a+Healthy+Plant-Based+Diet&qid=1603330140&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Benji Bean Sprout Doesn't Eat Meat",
        category: "",
        author: "Sarah Rudy",
        description: "",
        link: "https://www.amazon.com/Benji-Bean-Sprout-Doesnt-Meat/dp/097283401X/ref=sr_1_1?dchild=1&keywords=Benji+Bean+Sprout+Doesn%27t+Eat+Meat&qid=1603330184&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Bleating Hearts: The Hidden World of Animal Suffering",
        category: "",
        author: "Mark Hawthorne",
        description: "",
        link: "https://www.amazon.com/Bleating-Hearts-Hidden-Animal-Suffering-ebook/dp/B00G2R57D0/ref=sr_1_1?dchild=1&keywords=Bleating+Hearts%3A+The+Hidden+World+of+Animal+Suffering&qid=1603330211&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "But You Kill Ants",
        category: "",
        author: "John Waddell",
        description: "",
        link: "https://www.veganaustralia.org.au/but_you_kill_ants",
        "": "",
    },
    {
        type: "Books",
        name: "Change of Heart: What Psychology Can Teach Us About Spreading Social Change",
        category: "",
        author: "Nick Cooney",
        description: "",
        link: "https://www.amazon.com/Change-Heart-Psychology-Spreading-Social-ebook/dp/B07BTGLNJF/ref=sr_1_1?dchild=1&keywords=Change+of+Heart%3A+What+Psychology+Can+Teach+Us+About+Spreading+Social+Change&qid=1603330449&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Charlotte's Web",
        category: "",
        author: "E.B. White",
        description: "",
        link: "https://www.amazon.com/Charlottes-Web-B-White/dp/0061124958/ref=sr_1_1?crid=3GVZZ2NUSIBKF&dchild=1&keywords=charlottes+web+book&qid=1603330486&sprefix=Charlotte%2Caps%2C298&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Circles of Compassion: Essays Connecting Issues of Justice",
        category: "",
        author: "Will Tuttle",
        description: "",
        link: "https://www.amazon.com/Circles-Compassion-Essays-Connecting-Justice/dp/1940184061/ref=sr_1_1?dchild=1&keywords=Circles+of+Compassion%3A+Essays+Connecting+Issues+of+Justice&qid=1603330521&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Comfortably Unaware: What We Choose to Eat Is Killing Us and Our Planet",
        category: "",
        author: "Richard Oppenlander",
        description: "",
        link: "https://www.amazon.com/Comfortably-Unaware-Choose-Killing-Planet/dp/0825306868/ref=sr_1_1?dchild=1&keywords=Comfortably+Unaware%3A+What+We+Choose+to+Eat+Is+Killing+Us+and+Our+Planet&qid=1603330553&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Cows Are Vegetarians: A Book for Vegetarian Kids",
        category: "",
        author: "Ann Bradley",
        description: "",
        link: "https://www.amazon.com/Cows-Are-Vegetarians-Book-Vegetarian/dp/0963089307",
        "": "",
    },
    {
        type: "Books",
        name: "Cruel: Bearing Witness To Animal Exploitation",
        category: "",
        author: "Sue Coe",
        description: "",
        link: "https://www.amazon.com/Cruel-Bearing-Witness-Animal-Exploitation/dp/1935928724/ref=sr_1_1?dchild=1&keywords=Cruel%3A+Bearing+Witness+To+Animal+Exploitation&qid=1603330637&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Dave Loves Chickens",
        category: "",
        author: "Carlos Patino",
        description: "",
        link: "https://www.amazon.com/Dave-Loves-Chickens-VEGAN-CHILDRENS/dp/1940184010/ref=sr_1_1?dchild=1&keywords=Dave+Loves+Chickens&qid=1603330661&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Defiant Daughters: 21 Women on Art, Activism, Animals, and The Sexual Politics of Meat",
        category: "",
        author: "Kara Davis and Wendy Lee",
        description: "",
        link: "https://www.amazon.com/Defiant-Daughters-Activism-Politics-2013-03-19/dp/B017YBZE12/ref=sr_1_2?dchild=1&keywords=Defiant+Daughters%3A+21+Women+on+Art%2C+Activism%2C+Animals%2C+and+The+Sexual+Politics+of+Meat&qid=1603330703&s=books&sr=1-2",
        "": "",
    },
    {
        type: "Books",
        name: "Defining Critical Animal Studies: An Intersectional Social Justice Approach for Liberation",
        category: "",
        author: "Anthony J. Nocella II, John Sorenson, Kim Socha, Atsuko Matsuoka",
        description: "",
        link: "https://www.amazon.com/Defining-Critical-Animal-Studies-Intersectional/dp/1433121360/ref=sr_1_1?dchild=1&keywords=Defining+Critical+Animal+Studies%3A+An+Intersectional+Social+Justice+Approach+for+Liberation&qid=1603330759&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Diet for a New America, 25th anniversary edition (2012)",
        category: "",
        author: "John Robbins",
        description: "",
        link: "https://www.amazon.com/Diet-New-America-Anniversary-Happiness/dp/B07D6T5CKV/ref=sr_1_1?dchild=1&keywords=Diet+for+a+New+America%2C+25th+anniversary+edition+%282012%29&qid=1603330787&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Do Animals Have Feelings Too?",
        category: "",
        author: "David L. Rice",
        description: "",
        link: "https://www.amazon.com/Do-Animals-Have-Feelings-Too/dp/1584690046/ref=sr_1_1?dchild=1&keywords=Do+Animals+Have+Feelings+Too%3F&qid=1603330813&s=audible&sr=1-1-catcorr",
        "": "",
    },
    {
        type: "Books",
        name: "Do Unto Animals: A Friendly Guide to How Animals Live, and How We Can Make Their Lives Better",
        category: "",
        author: "Tracey Stewart",
        description: "",
        link: "https://www.amazon.com/Do-Unto-Animals-Friendly-Better/dp/1579656234/ref=sr_1_1?dchild=1&keywords=Do+Unto+Animals%3A+A+Friendly+Guide+to+How+Animals+Live%2C+and+How+We+Can+Make+Their+Lives+Better&qid=1603330846&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Dominion: The Power of Man, the Suffering of Animals, and the Call to Mercy",
        category: "",
        author: "Matthew Scully",
        description: "",
        link: "https://www.amazon.com/Dominion-Power-Suffering-Animals-Mercy/dp/0312319738/ref=sr_1_1?dchild=1&keywords=Dominion%3A+The+Power+of+Man%2C+the+Suffering+of+Animals%2C+and+the+Call+to+Mercy&qid=1603330873&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Eat Like You Care: An Examination of the Morality of Eating Animals",
        category: "",
        author: "Gary L Francione, Anna Charlton",
        description: "",
        link: "https://www.amazon.com/Eat-Like-You-Care-Examination/dp/1492386510/ref=sr_1_1?dchild=1&keywords=Eat+Like+You+Care%3A+An+Examination+of+the+Morality+of+Eating+Animals&qid=1603330900&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Eating Animals",
        category: "",
        author: "Jonathan Safran Foer",
        description: "",
        link: "https://www.amazon.com/Eating-Animals-Jonathan-Safran-Foer/dp/0316069884/ref=sr_1_1?dchild=1&keywords=Eating+Animals&qid=1603330925&sr=8-11",
        "": "",
    },
    {
        type: "Books",
        name: "Empty Cages: Facing the Challenge of Animal Rights",
        category: "",
        author: "Tom Regan",
        description: "",
        link: "https://www.amazon.com/Empty-Cages-Facing-Challenge-Animal/dp/0742533522/ref=sr_1_1?dchild=1&keywords=Empty+Cages%3A+Facing+the+Challenge+of+Animal+Rights&qid=1603330958&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Entangled Empathy: An Alternative Ethic for Our Relationships with Animals",
        category: "",
        author: "Lori Gruen",
        description: "",
        link: "https://www.amazon.com/Entangled-Empathy-Alternative-Relationships-Animals/dp/1590564871/ref=sr_1_1?dchild=1&keywords=Entangled+Empathy%3A+An+Alternative+Ethic+for+Our+Relationships+with+Animals&qid=1603331072&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Esther the Wonder Pig:Changing the World One Heart at a Time",
        category: "",
        author: "Steve Jenkins, Derek Walter, Caprice Crane",
        description: "",
        link: "https://www.amazon.com/Esther-Wonder-Pig-Changing-World/dp/1455560790/ref=sr_1_1?dchild=1&keywords=Esther+the+Wonder+Pig%3AChanging+the+World+One+Heart+at+a+Time&qid=1603331092&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Eternal Treblinka: Our Treatment of Animals and the Holocaust",
        category: "",
        author: "Charles Patterson",
        description: "",
        link: "https://www.amazon.com/Eternal-Treblinka-Treatment-Animals-Holocaust-ebook/dp/B005AHOZ7W/ref=sr_1_1?dchild=1&keywords=Eternal+Treblinka%3A+Our+Treatment+of+Animals+and+the+Holocaust&qid=1603331128&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Ethics and Animals: An Introduction",
        category: "",
        author: "Lori Gruen",
        description: "",
        link: "https://www.amazon.com/Ethics-Animals-Introduction-Cambridge-Applied/dp/0521717736/ref=sr_1_1?dchild=1&keywords=Ethics+and+Animals%3A+An+Introduction&qid=1603331150&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Every Twelve Seconds: Industrialized Slaughter and the Politics of Sight",
        category: "",
        author: "Timothy Pachirat",
        description: "",
        link: "https://www.amazon.com/Every-Twelve-Seconds-Industrialized-Slaughter/dp/0300192487/ref=sr_1_1?dchild=1&keywords=Every+Twelve+Seconds%3A+Industrialized+Slaughter+and+the+Politics+of+Sight&qid=1603331178&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Farm Sanctuary: Changing Hearts and Minds About Animals and Food",
        category: "",
        author: "Gene Baur",
        description: "",
        link: "https://www.amazon.com/Farm-Sanctuary-Changing-Hearts-Animals/dp/074329159X/ref=sr_1_1?dchild=1&keywords=Farm+Sanctuary%3A+Changing+Hearts+and+Minds+About+Animals+and+Food&qid=1603331209&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Farmageddon: The True Cost of Cheap Meat",
        category: "",
        author: "Philip Lymbery, Isabel Oakeshott",
        description: "",
        link: "https://www.amazon.com/Farmageddon-True-Cost-Cheap-Meat-ebook/dp/B00HW0TKWU/ref=sr_1_1?dchild=1&keywords=Farmageddon%3A+The+True+Cost+of+Cheap+Meat&qid=1603331239&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Food, Inc.",
        category: "",
        author: "Karl Weber",
        description: "",
        link: "https://www.amazon.com/Food-Inc-Participant-Industrial-Poorer/dp/1586486942/ref=sr_1_2?dchild=1&keywords=Food%2C+Inc.&qid=1603331264&sr=8-2",
        "": "",
    },
    {
        type: "Books",
        name: "For Love of Animals: Christian Ethics, Consistent Action",
        category: "",
        author: "Charles C. Camosy",
        description: "",
        link: "https://www.amazon.com/Love-Animals-Christian-Ethics-Consistent/dp/1616366621/ref=sr_1_1?dchild=1&keywords=For+Love+of+Animals%3A+Christian+Ethics%2C+Consistent+Action&qid=1603331293&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "For the Prevention of Cruelty: The History and Legacy of Animal Rights Activism in the United States",
        category: "",
        author: "Diane L. Beers",
        description: "",
        link: "https://www.amazon.com/Prevention-Cruelty-History-Legacy-Activism/dp/0804010870/ref=sr_1_1?dchild=1&keywords=For+the+Prevention+of+Cruelty%3A+The+History+and+Legacy+of+Animal+Rights+Activism+in+the+United+States&qid=1603331321&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Generation V : the complete guide to going, being, and staying vegan as a teenager",
        category: "",
        author: "Claire Askew",
        description: "",
        link: "https://www.amazon.com/Generation-Complete-Guide-Staying-Teenager/dp/0977080447/ref=sr_1_1?dchild=1&keywords=Generation+V+%3A+the+complete+guide+to+going%2C+being%2C+and+staying+vegan+as+a+teenager&qid=1603331345&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Goosie's Story",
        category: "",
        author: "Louise Van Der Merwe",
        description: "",
        link: "https://www.amazon.com/gp/product/1860331955/",
        "": "",
    },
    {
        type: "Books",
        name: "Green is the New Red: An Insider's Account of a Social Movement Under Siege",
        category: "",
        author: "Will Potter",
        description: "",
        link: "https://www.amazon.com/Green-New-Red-Insiders-Movement/dp/087286538X/ref=sr_1_1?dchild=1&keywords=Green+is+the+New+Red%3A+An+Insider%27s+Account+of+a+Social+Movement+Under+Siege&qid=1603331442&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Growl: Life Lessons, Hard Truths, and Bold Strategies from an Animal Advocate",
        category: "",
        author: "Kim Stallwood",
        description: "",
        link: "https://www.amazon.com/Growl-Lessons-Truths-Strategies-Advocate-ebook/dp/B00KQUJO10/ref=sr_1_1?dchild=1&keywords=Growl%3A+Life+Lessons%2C+Hard+Truths%2C+and+Bold+Strategies+from+an+Animal+Advocate&qid=1603331465&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Harmony on the Farm: Harmony Becomes a Vegetarian!",
        category: "",
        author: "Sean R Smith",
        description: "",
        link: "https://www.amazon.com/Harmony-Farm-Becomes-Vegetarian-ebook/dp/B009NK3YI8/ref=sr_1_1?dchild=1&keywords=Harmony+on+the+Farm%3A+Harmony+Becomes+a+Vegetarian%21&qid=1603331490&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Hope:A Pig's Tale",
        category: "",
        author: "Randy Houk",
        description: "",
        link: "https://www.amazon.com/Hope-Humane-Society-United-States/dp/1882728343/ref=sr_1_1?dchild=1&keywords=Hope%3AA+Pig%27s+Tale&qid=1603331512&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "How to Be Vegan: Tips, Tricks, and Strategies for Cruelty-Free Eating, Living, Dating, Travel, Decorating, and More",
        category: "",
        author: "Elizabeth Castoria",
        description: "",
        link: "https://www.amazon.com/How-Vegan-Strategies-Cruelty-Free-Decorating/dp/1579655556/ref=sr_1_1?dchild=1&keywords=How+to+Be+Vegan%3A+Tips%2C+Tricks%2C+and+Strategies+for+Cruelty-Free+Eating%2C+Living%2C+Dating%2C+Travel%2C+Decorating%2C+and+More&qid=1603331536&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Hubert the Pudge: A Vegetarian Tale",
        category: "",
        author: "Henrik Drescher",
        description: "",
        link: "https://www.amazon.com/Hubert-Pudge-Vegetarian-Henrik-Drescher/dp/0763619922/ref=sr_1_1?dchild=1&keywords=Hubert+the+Pudge%3A+A+Vegetarian+Tale&qid=1603331788&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "In Defense of Animals: The Second Wave",
        category: "",
        author: "Peter Singer",
        description: "",
        link: "https://www.amazon.com/Defense-Animals-Second-Wave-ebook/dp/B00CY5HK48/ref=sr_1_1?dchild=1&keywords=In+Defense+of+Animals%3A+The+Second+Wave&qid=1603331819&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Instead of Chicken, Instead of Turkey: A Poultryless Poultry Potpourri",
        category: "",
        author: "Karen Davis",
        description: "",
        link: "https://www.amazon.com/Instead-Chicken-Turkey-Poultryless-Potpourri/dp/1570670838/ref=sr_1_1?dchild=1&keywords=Instead+of+Chicken%2C+Instead+of+Turkey%3A+A+Poultryless+Poultry+Potpourri&qid=1603331842&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Introduction to Animal Rights: Your Child or the Dog?",
        category: "",
        author: "Gary L. Francione",
        description: "",
        link: "https://www.amazon.com/Introduction-Animal-Rights-Your-Child-ebook/dp/B00511N2X0/ref=sr_1_1?dchild=1&keywords=Introduction+to+Animal+Rights%3A+Your+Child+or+the+Dog%3F&qid=1603331962&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Kind",
        category: "",
        author: "Gretchen Primack",
        description: "",
        link: "https://www.amazon.com/Kind-Poems-Gretchen-Primack/dp/0989022900",
        "": "",
    },
    {
        type: "Books",
        name: "Lena of Vegitopia and the Mystery of the Missing Animals",
        category: "",
        author: "Sybil Severin",
        description: "",
        link: "https://www.amazon.com/Vegitopia-Mystery-Missing-Animals-CHILDRENS/dp/1940184002/ref=sr_1_1?dchild=1&keywords=Lena+of+Vegitopia+and+the+Mystery+of+the+Missing+Animals&qid=1603332067&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Letters to a New Vegan: Letters to Inform, Inspire, and Support a Vegan Lifestyle",
        category: "",
        author: "Justin Van Kleek, Melissa Tedrowe",
        description: "",
        link: "https://www.amazon.com/Letters-New-Vegan-Inspire-Lifestyle-ebook/dp/B00XN6RE98/ref=sr_1_1?dchild=1&keywords=Letters+to+a+New+Vegan%3A+Letters+to+Inform%2C+Inspire%2C+and+Support+a+Vegan+Lifestyle&qid=1603332094&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Linus the Vegetarian T. Rex",
        category: "",
        author: "Robert Neubecker",
        description: "",
        link: "https://www.amazon.com/Linus-Vegetarian-rex-Robert-Neubecker/dp/1416985123/ref=sr_1_1?dchild=1&keywords=Linus+the+Vegetarian+T.+Rex&qid=1603332191&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Living Among Meat Eaters",
        category: "",
        author: "Carol J. Adams",
        description: "",
        link: "https://www.amazon.com/Living-among-Meat-Eaters-Vegetarians/dp/1590561163/ref=sr_1_1?dchild=1&keywords=Living+Among+Meat+Eaters&qid=1603332224&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Living the Farm Sanctuary Life: The Ultimate Guide to Eating Mindfully, Living Longer, and Feeling Better Every Day",
        category: "",
        author: "Gene Baur, Gene Stone",
        description: "",
        link: "https://www.amazon.com/Living-Farm-Sanctuary-Life-Mindfully/dp/1623364892/ref=sr_1_1?dchild=1&keywords=Living+the+Farm+Sanctuary+Life%3A+The+Ultimate+Guide+to+Eating+Mindfully%2C+Living+Longer%2C+and+Feeling+Better+Every+Day&qid=1603332259&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Mad Cowboy: Plain Truth from the Cattle Rancher Who Won't Eat Meat",
        category: "",
        author: "Howard F. Lyman, Glen Merzer",
        description: "",
        link: "https://www.amazon.com/Mad-Cowboy-Plain-Cattle-Rancher/dp/0684854465/ref=sr_1_1?dchild=1&keywords=Mad+Cowboy%3A+Plain+Truth+from+the+Cattle+Rancher+Who+Won%27t+Eat+Meat&qid=1603332286&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Main Street Vegan: Everything You Need to Know to Eat Healthfully and Live Compassionately in the Real World",
        category: "",
        author: "Victoria Moran, Adair Moran",
        description: "",
        link: "https://www.amazon.com/Main-Street-Vegan-Healthfully-Compassionately/dp/1585429333/ref=sr_1_1?dchild=1&keywords=Main+Street+Vegan%3A+Everything+You+Need+to+Know+to+Eat+Healthfully+and+Live+Compassionately+in+the+Real+World&qid=1603332390&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Meatonomics: How the Rigged Economics of Meat and Dairy Make You Consume Too Much-and How to Eat Better, Live Longer, and Spend Smarter",
        category: "",
        author: "David Robinson Simon",
        description: "",
        link: "https://www.amazon.com/Meatonomics-Economics-Consume-Much-Smarter/dp/1573246204/ref=sr_1_1?dchild=1&keywords=Meatonomics%3A+How+the+Rigged+Economics+of+Meat+and+Dairy+Make+You+Consume+Too+Much-and+How+to+Eat+Better%2C+Live+Longer%2C+and+Spend+Smarter&qid=1603332414&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Mind If I Order the Cheeseburger?: And Other Questions People Ask Vegans",
        category: "",
        author: "Sherry F. Colb",
        description: "",
        link: "https://www.amazon.com/Mind-If-Order-Cheeseburger-Questions/dp/B07K1LQ6FW/ref=sr_1_1?dchild=1&keywords=Mind+If+I+Order+the+Cheeseburger%3F%3A+And+Other+Questions+People+Ask+Vegans&qid=1603332467&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Minny's Dream",
        category: "",
        author: "Clare Druce",
        description: "",
        link: "https://www.amazon.com/gp/product/1903491215/",
        "": "",
    },
    {
        type: "Books",
        name: "More Than a Meal: The Turkey in History, Myth, Ritual, and Reality",
        category: "",
        author: "Karen Davis",
        description: "",
        link: "https://www.amazon.com/More-than-Meal-History-Reality-ebook/dp/B003M5H6W0/ref=sr_1_1?dchild=1&keywords=More+Than+a+Meal%3A+The+Turkey+in+History%2C+Myth%2C+Ritual%2C+and+Reality&qid=1603332552&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Most Good, Least Harm: A Simple Principle for a Better World and Meaningful Life",
        category: "",
        author: "Zoe Weil",
        description: "",
        link: "https://www.amazon.com/Most-Good-Least-Harm-Meaningful/dp/1582702063/ref=sr_1_1?dchild=1&keywords=Most+Good%2C+Least+Harm%3A+A+Simple+Principle+for+a+Better+World+and+Meaningful+Life&qid=1603332590&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Motivational Methods for Vegan Advocacy: A Clinical Psychology Perspective",
        category: "",
        author: "Casey T. Taft",
        description: "",
        link: "https://www.amazon.com/Motivational-Methods-Vegan-Advocacy-Perspective-ebook/dp/B01BUPF9GS/ref=sr_1_1?dchild=1&keywords=Motivational+Methods+for+Vegan+Advocacy%3A+A+Clinical+Psychology+Perspective&qid=1603332620&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "My Gentle Barn: Creating a Sanctuary Where Animals Heal and Children Learn to Hope",
        category: "",
        author: "Ellie Laks, Nomi Isak",
        description: "",
        link: "https://www.amazon.com/My-Gentle-Barn-Creating-Sanctuary/dp/0385347669/ref=sr_1_1?dchild=1&keywords=My+Gentle+Barn%3A+Creating+a+Sanctuary+Where+Animals+Heal+and+Children+Learn+to+Hope&qid=1603332640&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "My Mom Eats Tofu",
        category: "",
        author: "Robyn Ringgold",
        description: "",
        link: "https://www.amazon.com/My-Mom-Eats-Tofu-Book-ebook/dp/B00AO7PLEE/ref=sr_1_1?dchild=1&keywords=My+Mom+Eats+Tofu&qid=1603332663&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Neither Man nor Beast: Feminism and the Defense of Animals",
        category: "",
        author: "Carol Adams",
        description: "",
        link: "https://www.amazon.com/Neither-Man-Nor-Beast-Feminism/dp/082640670X/ref=sr_1_2?dchild=1&keywords=Neither+Man+nor+Beast%3A+Feminism+and+the+Defense+of+Animals&qid=1603332689&sr=8-2",
        "": "",
    },
    {
        type: "Books",
        name: "Never Too Late to Go Vegan: The Over-50 Guide to Adopting and Thriving on a Plant-Based Diet",
        category: "",
        author: "Carol J. Adams, Patti Breitman, Virginia Messina",
        description: "",
        link: "https://www.amazon.com/Never-Too-Late-Vegan-Plant-Based/dp/1615190988/ref=sr_1_1?dchild=1&keywords=Never+Too+Late+to+Go+Vegan%3A+The+Over-50+Guide+to+Adopting+and+Thriving+on+a+Plant-Based+Diet&qid=1603332716&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Ninety-Five: Meeting America's Farmed Animals in Stories and Photographs",
        category: "",
        author: "No Voice Unheard",
        description: "",
        link: "https://www.amazon.com/Ninety-Five-Meeting-Americas-Animals-Photographs/dp/0972838759/ref=sr_1_1?dchild=1&keywords=Ninety-Five%3A+Meeting+America%27s+Farmed+Animals+in+Stories+and+Photographs&qid=1603332745&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Not a Nugget",
        category: "",
        author: "Stephanie Dreyer",
        description: "",
        link: "https://www.amazon.com/Not-Nugget-Stephanie-Dreyer/dp/0986106011/ref=sr_1_1?dchild=1&keywords=Not+a+Nugget&qid=1603332785&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Our Companion Animals : Tales of Transformation from Farm Sanctuary",
        category: "",
        author: "Gene Bauston (Editor), Lorri Bauston (Editor)",
        description: "",
        link: "https://www.amazon.com/Our-Companion-Animals-Transformation-Sanctuary/dp/1930051239/ref=sr_1_1?dchild=1&keywords=Our+Companion+Animals+%3A+Tales+of+Transformation+from+Farm+Sanctuary&qid=1603332806&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Our farm : by the animals of Farm Sanctuary",
        category: "",
        author: "Maya Gottfried",
        description: "",
        link: "https://www.amazon.com/Our-Farm-Animals-Sanctuary-ebook/dp/B0075WPE0C/ref=sr_1_3?dchild=1&keywords=Our+farm+%3A+by+the+animals+of+Farm+Sanctuary&qid=1603332834&sr=8-3",
        "": "",
    },
    {
        type: "Books",
        name: "Pleasurable Kingdom: Animals and the Nature of Feeling Good",
        category: "",
        author: "Jonathan Balcombe",
        description: "",
        link: "https://www.amazon.com/Pleasurable-Kingdom-Animals-Nature-Feeling-ebook/dp/B001BNT4C0/ref=sr_1_1?dchild=1&keywords=Pleasurable+Kingdom%3A+Animals+and+the+Nature+of+Feeling+Good&qid=1603332865&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Powerful Vegan Messages:Out of the Jungle for the Next Generation",
        category: "",
        author: "H. Jay Dinshah and Anne Dinshah",
        description: "",
        link: "https://www.amazon.com/Powerful-Vegan-Messages-Jungle-Generation-ebook/dp/B00MXEYKPC/ref=sr_1_1?dchild=1&keywords=Powerful+Vegan+Messages%3AOut+of+the+Jungle+for+the+Next+Generation&qid=1603332891&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Prisoned Chickens, Poisoned Eggs: An Inside Look at the Modern Poultry Industry",
        category: "",
        author: "Karen Davis",
        description: "",
        link: "https://www.amazon.com/Prisoned-Chickens-Poisoned-Eggs-Industry-ebook/dp/B00HZVA9XA/ref=sr_1_1?dchild=1&keywords=Prisoned+Chickens%2C+Poisoned+Eggs%3A+An+Inside+Look+at+the+Modern+Poultry+Industry&qid=1603332914&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Project animal farm: an accidental journey into the secret world of farming and the truth about our food",
        category: "",
        author: "Sonia Faruqi",
        description: "",
        link: "https://www.amazon.com/Project-Animal-Farm-Accidental-Journey-ebook/dp/B00QO4CWZW/ref=sr_1_1?dchild=1&keywords=Project+animal+farm%3A+an+accidental+journey+into+the+secret+world+of+farming+and+the+truth+about+our+food&qid=1603332949&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Proteinaholic: How Our Obsession with Meat Is Killing Us and What We Can Do About It",
        category: "",
        author: "Garth, M.D. Davis, Howard Jacobson",
        description: "",
        link: "https://www.amazon.com/Proteinaholic-Obsession-Meat-Killing-About/dp/0062279319/ref=sr_1_1?dchild=1&keywords=Proteinaholic%3A+How+Our+Obsession+with+Meat+Is+Killing+Us+and+What+We+Can+Do+About+It&qid=1603332970&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Running, Eating, Thinking: A Vegan Anthology",
        category: "",
        author: "Martin Rowe",
        description: "",
        link: "https://www.amazon.com/Running-Eating-Thinking-Vegan-Anthology-ebook/dp/B00KFMLB9C/ref=sr_1_1?dchild=1&keywords=Running%2C+Eating%2C+Thinking%3A+A+Vegan+Anthology&qid=1603332996&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Sanctuary: Portraits of Rescued Farm Animals",
        category: "",
        author: "Sharon Lee Hart",
        description: "",
        link: "https://www.amazon.com/Sharon-Lee-Hart-Sanctuary-Portraits/dp/8881588455/ref=sr_1_1?dchild=1&keywords=Sanctuary%3A+Portraits+of+Rescued+Farm+Animals&qid=1603333014&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Second Nature: The Inner Lives of Animals",
        category: "",
        author: "Jonathan Balcombe",
        description: "",
        link: "https://www.amazon.com/Second-Nature-Inner-Animals-MacSci/dp/0230107818/ref=sr_1_1?dchild=1&keywords=Second+Nature%3A+The+Inner+Lives+of+Animals&qid=1603333058&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Sistah Vegan: Black Female Vegans Speak on Food, Identity, Health, and Society",
        category: "",
        author: "A. Breeze Harper, pattrice jones",
        description: "",
        link: "https://www.amazon.com/Sistah-Vegan-Female-Identity-Society/dp/1590561457/ref=sr_1_1?dchild=1&keywords=Sistah+Vegan%3A+Black+Female+Vegans+Speak+on+Food%2C+Identity%2C+Health%2C+and+Society&qid=1603333135&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Sister Species: Women, Animals, and Social Justice",
        category: "",
        author: "Lisa A. Kemmerer",
        description: "",
        link: "https://www.amazon.com/Sister-Species-Animals-Social-Justice/dp/025207811X/ref=sr_1_1?dchild=1&keywords=Sister+Species%3A+Women%2C+Animals%2C+and+Social+Justice&qid=1603333161&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Skinny Bitch",
        category: "",
        author: "Rory Freedman, Kim Barnouin",
        description: "",
        link: "https://www.amazon.com/Skinny-Bitch-No-Nonsense-Tough-Love-Fabulous/dp/0762424931/ref=sr_1_1?dchild=1&keywords=skinny+bitch&qid=1603333177&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Slaughterhouse: The Shocking Story of Greed, Neglect, and Inhumane Treatment Inside the U.S. Meat Industry",
        category: "",
        author: "Gail A. Eisnitz",
        description: "",
        link: "https://www.amazon.com/Slaughterhouse-Shocking-Inhumane-Treatment-Industry/dp/1591024501/ref=sr_1_1?dchild=1&keywords=Slaughterhouse%3A+The+Shocking+Story+of+Greed%2C+Neglect%2C+and+Inhumane+Treatment+Inside+the+U.S.+Meat+Industry&qid=1603333198&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Sometimes It's Turkey, Sometimes It's Feathers",
        category: "",
        author: "Lorna Balian, Lecia Balian",
        description: "",
        link: "https://www.amazon.com/Sometimes-Its-Turkey-Feathers/dp/1932065415/ref=sr_1_1?dchild=1&keywords=Sometimes+It%27s+Turkey%2C+Sometimes+It%27s+Feathers&qid=1603333220&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Steven the Vegan",
        category: "",
        author: "Dan Bodenstein",
        description: "",
        link: "https://www.amazon.com/Steven-Vegan-Dan-Bodenstein/dp/0984322892/ref=sr_1_1?dchild=1&keywords=Steven+the+Vegan&qid=1603333240&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Strategic Action for Animals: A Handbook on Strategic Movement Building, Organizing, and Activism for Animal Liberation",
        category: "",
        author: "Melanie Joy",
        description: "",
        link: "https://www.amazon.com/Strategic-Action-Animals-Organizing-Liberation/dp/1590561368/ref=sr_1_1?dchild=1&keywords=Strategic+Action+for+Animals%3A+A+Handbook+on+Strategic+Movement+Building%2C+Organizing%2C+and+Activism+for+Animal+Liberation&qid=1603333258&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Striking at the Roots: A Practical Guide to Animal Activism",
        category: "",
        author: "Mark Hawthorne",
        description: "",
        link: "https://www.amazon.com/Striking-Roots-Practical-Animal-Activism-ebook/dp/B004GXAZZM/ref=sr_1_1?dchild=1&keywords=Striking+at+the+Roots%3A+A+Practical+Guide+to+Animal+Activism&qid=1603333283&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Thanking the Monkey: Rethinking the Way We Treat Animals",
        category: "",
        author: "Karen Dawn",
        description: "",
        link: "https://www.amazon.com/Thanking-Monkey-Rethinking-Treat-Animals/dp/0061351857/ref=sr_1_1?dchild=1&keywords=Thanking+the+Monkey%3A+Rethinking+the+Way+We+Treat+Animals&qid=1603333315&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "That’s Why We Don’t Eat Animals: A Book About Vegans, Vegetarians, and All Living Things",
        category: "",
        author: "Ruby Roth",
        description: "",
        link: "https://www.amazon.com/Thats-Why-Dont-Eat-Animals/dp/1556437854/ref=sr_1_1?dchild=1&keywords=That’s+Why+We+Don’t+Eat+Animals%3A+A+Book+About+Vegans%2C+Vegetarians%2C+and+All+Living+Things&qid=1603333337&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Accidental Activist",
        category: "",
        author: "Matt Ball",
        description: "",
        link: "https://www.amazon.com/Accidental-Activist-Interviews-Outreachs-Cofounder/dp/B07HFH1L9K/ref=sr_1_2?dchild=1&keywords=The+Accidental+Activist&qid=1603333358&sr=8-2",
        "": "",
    },
    {
        type: "Books",
        name: "The Adventures of Vivian Sharpe, Vegan Superhero",
        category: "",
        author: "Marla Rose",
        description: "",
        link: "https://www.amazon.com/Adventures-Vivian-Sharpe-Vegan-Superhero-ebook/dp/B0076ZDXW4/ref=sr_1_1?dchild=1&keywords=The+Adventures+of+Vivian+Sharpe%2C+Vegan+Superhero&qid=1603333395&s=audible&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Animal Activist's Handbook: Maximizing Our Positive Impact in Today’s World",
        category: "",
        author: "Matt Ball and Bruce Friedrich",
        description: "",
        link: "https://www.amazon.com/Animal-Activists-Handbook-Maximizing-Flashpoint/dp/1590561201/ref=sr_1_1?dchild=1&keywords=The+Animal+Activist%27s+Handbook%3A+Maximizing+Our+Positive+Impact+in+Today’s+World&qid=1603333745&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Animal Rights Debate: Abolition or Regulation? (Critical Perspectives on Animals: Theory, Culture, Science, and Law)",
        category: "",
        author: "Gary L. Francione, Robert Garner",
        description: "",
        link: "https://www.amazon.com/Animal-Rights-Debate-Regulation-Perspectives/dp/0231149557/ref=sr_1_1?dchild=1&keywords=The+Animal+Rights+Debate%3A+Abolition+or+Regulation%3F+%28Critical+Perspectives+on+Animals%3A+Theory%2C+Culture%2C+Science%2C+and+Law%29&qid=1603333781&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Awareness",
        category: "",
        author: "Gene Stone, Jon Doyle",
        description: "",
        link: "https://www.amazon.com/Awareness-Gene-Stone/dp/0615944647/ref=sr_1_2?dchild=1&keywords=The+Awareness&qid=1603333806&sr=8-2",
        "": "",
    },
    {
        type: "Books",
        name: "The Bond: Our Kinship with Animals, Our Call to Defend Them",
        category: "",
        author: "Wayne Pacelle",
        description: "",
        link: "https://www.amazon.com/gp/product/0061969788",
        "": "",
    },
    {
        type: "Books",
        name: "The Buddha, The Vegan, and You: Part1: Meat, Myself and Irony (Volume 1)",
        category: "",
        author: "John Bussineau",
        description: "",
        link: "https://www.amazon.com/Buddha-Vegan-You-Part1-Myself/dp/0997002905/ref=sr_1_1?dchild=1&keywords=The+Buddha%2C+The+Vegan%2C+and+You%3A+Part1%3A+Meat%2C+Myself+and+Irony+%28Volume+1%29&qid=1603333944&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Case for Animal Rights",
        category: "",
        author: "Tom Regan",
        description: "",
        link: "https://www.amazon.com/Case-Animal-Rights-Tom-Regan/dp/0520243862/ref=sr_1_1?dchild=1&keywords=The+Case+for+Animal+Rights&qid=1603334244&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Chain (The Kinship Series) (Volume 1)",
        category: "",
        author: "Robin Lamont",
        description: "",
        link: "https://www.amazon.com/Chain-Kinship-Book-1-ebook/dp/B00FFGNRPO/ref=sr_1_1?dchild=1&keywords=The+Chain+%28The+Kinship+Series%29+%28Volume+1%29&qid=1603334279&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Chain: Farm, Factory, and the Fate of Our Food",
        category: "",
        author: "Ted Genoways",
        description: "",
        link: "https://www.amazon.com/Chain-Farm-Factory-Fate-Food/dp/0062288768/ref=sr_1_1?dchild=1&keywords=The+Chain%3A+Farm%2C+Factory%2C+and+the+Fate+of+Our+Food&qid=1603334331&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Chicken Gave it to Me",
        category: "",
        author: "Anne Fine",
        description: "",
        link: "https://www.amazon.com/Chicken-Gave-Anne-Fine-author/dp/1405289023/ref=sr_1_1?dchild=1&keywords=The+Chicken+Gave+it+to+Me&qid=1603334350&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The China Study: The Most Comprehensive Study of Nutrition Ever Conducted And the Startling Implications for Diet, Weight Loss, And Long-term Health",
        category: "",
        author: "Thomas Campbell, T. Colin Campbell",
        description: "",
        link: "https://www.amazon.com/China-Study-Comprehensive-Nutrition-Implications/dp/1941631568/ref=sr_1_1?dchild=1&keywords=The+China+Study%3A+The+Most+Comprehensive+Study+of+Nutrition+Ever+Conducted+And+the+Startling+Implications+for+Diet%2C+Weight+Loss%2C+And+Long-term+Health&qid=1603334390&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Dreaded Comparison: Human and Animal Slavery",
        category: "",
        author: "Marjorie Spiegel",
        description: "",
        link: "https://www.amazon.com/Dreaded-Comparison-Human-Animal-Slavery/dp/0962449334/ref=sr_1_1?dchild=1&keywords=The+Dreaded+Comparison%3A+Human+and+Animal+Slavery&qid=1603334409&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Emotional Lives of Animals & Children: Insights from a Farm Sanctuary",
        category: "",
        author: "William Crain",
        description: "",
        link: "https://www.amazon.com/Emotional-Lives-Animals-Children-Sanctuary/dp/1618520822/ref=sr_1_1?dchild=1&keywords=The+Emotional+Lives+of+Animals+%26+Children%3A+Insights+from+a+Farm+Sanctuary&qid=1603334439&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Face on Your Plate: The Truth About Food",
        category: "",
        author: "Jeffrey Moussaieff Masson",
        description: "",
        link: "https://www.amazon.com/Face-Your-Plate-Truth-About/dp/0393338150/ref=sr_1_1?dchild=1&keywords=The+Face+on+Your+Plate%3A+The+Truth+About+Food&qid=1603334460&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Global Guide to Animal Protection",
        category: "",
        author: "Andrew Linzey",
        description: "",
        link: "https://www.amazon.com/Global-Guide-Animal-Protection-ebook/dp/B00CRQS46M/ref=sr_1_1?dchild=1&keywords=The+Global+Guide+to+Animal+Protection&qid=1603334488&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Holocaust & the Henmaid’s Tale: A Case for Comparing Atrocities",
        category: "",
        author: "Karen Davis",
        description: "",
        link: "https://www.amazon.com/Holocaust-Henmaids-Tale-Comparing-Atrocities/dp/1590560914/ref=sr_1_1?dchild=1&keywords=The+Holocaust+%26+the+Henmaid’s+Tale%3A+A+Case+for+Comparing+Atrocities&qid=1603334513&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Humane Economy: How Innovators and Enlightened Consumers Are Transforming the Lives of Animals",
        category: "",
        author: "Wayne Pacelle",
        description: "",
        link: "https://www.amazon.com/Humane-Economy-Innovators-Enlightened-Transforming/dp/0062389645/ref=sr_1_1?dchild=1&keywords=The+Humane+Economy%3A+How+Innovators+and+Enlightened+Consumers+Are+Transforming+the+Lives+of+Animals&qid=1603334566&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Inner World of Farm Animals: Their Amazing Social, Emotional, and Intellectual Capacities",
        category: "",
        author: "Amy Hatkoff",
        description: "",
        link: "https://www.amazon.com/Inner-World-Farm-Animals-Intellectual/dp/1584797487/ref=sr_1_1?dchild=1&keywords=The+Inner+World+of+Farm+Animals%3A+Their+Amazing+Social%2C+Emotional%2C+and+Intellectual+Capacities&qid=1603334584&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Longest Struggle: Animal Advocacy from Pythagoras to Peta",
        category: "",
        author: "Norm Phelps",
        description: "",
        link: "https://www.amazon.com/Longest-Struggle-Animal-Advocacy-Pythagoras/dp/1590561066/ref=sr_1_1?dchild=1&keywords=The+Longest+Struggle%3A+Animal+Advocacy+from+Pythagoras+to+Peta&qid=1603334610&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Lucky Ones: My Passionate Fight for Farm Animals",
        category: "",
        author: "Jenny Brown",
        description: "",
        link: "https://www.amazon.com/Lucky-Ones-Passionate-Fight-Animals/dp/B00CAYMAJ8/ref=sr_1_1?dchild=1&keywords=The+Lucky+Ones%3A+My+Passionate+Fight+for+Farm+Animals&qid=1603334633&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Modern Savage: Our Unthinking Decision to Eat Animals",
        category: "",
        author: "James McWilliams",
        description: "",
        link: "https://www.amazon.com/Modern-Savage-Unthinking-Decision-Animals/dp/1250070228/ref=sr_1_1?dchild=1&keywords=The+Modern+Savage%3A+Our+Unthinking+Decision+to+Eat+Animals&qid=1603334711&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Oxford Handbook of Animal Ethics",
        category: "",
        author: "Tom L. Beauchamp, R.G. Frey",
        description: "",
        link: "https://www.amazon.com/Oxford-Handbook-Animal-Ethics-Handbooks/dp/019935197X/ref=sr_1_1?dchild=1&keywords=The+Oxford+Handbook+of+Animal+Ethics&qid=1603334665&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Pig Who Sang to the Moon: The Emotional World of Farm Animals",
        category: "",
        author: "Jeffrey Moussaieff Masson",
        description: "",
        link: "https://www.amazon.com/Pig-Who-Sang-Moon-Emotional/dp/034545281X/ref=sr_1_1?dchild=1&keywords=The+Pig+Who+Sang+to+the+Moon%3A+The+Emotional+World+of+Farm+Animals&qid=1603334742&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Plant-Based Journey: A Step-by-Step Guide for Transitioning to a Healthy Lifestyle and Achieving Your Ideal Weight",
        category: "",
        author:
            "Lani Muelrath, T. Colin Campbell Ph.D., Howard Jacobson, Neal Barnard",
        description: "",
        link: "https://www.amazon.com/Plant-Based-Journey-Step-Step-Transitioning/dp/1941631363/ref=sr_1_1?dchild=1&keywords=The+Plant-Based+Journey%3A+A+Step-by-Step+Guide+for+Transitioning+to+a+Healthy+Lifestyle+and+Achieving+Your+Ideal+Weight&qid=1603334781&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Sexual Politics of Meat: A Feminist-Vegetarian Critical Theory, 20th anniversary edition (2010)",
        category: "",
        author: "Carol J. Adams",
        description: "",
        link: "https://www.amazon.com/Sexual-Politics-Meat-Anniversary-Feminist-Vegetarian/dp/B08J48GZSB/ref=sr_1_fkmr1_1?dchild=1&keywords=The+Sexual+Politics+of+Meat%3A+A+Feminist-Vegetarian+Critical+Theory%2C+20th+anniversary+edition+%282010%29&qid=1603334824&s=books&sr=1-1-fkmr1",
        "": "",
    },
    {
        type: "Books",
        name: "The Sustainability Secret: Rethinking Our Diet to Transform the World",
        category: "",
        author: "Keegan Kuhn, Kip Andersen, Chris Hedges",
        description: "",
        link: "https://www.amazon.com/Sustainability-Secret-Kip-Anderson-ebook/dp/B01IA7TLNQ/ref=sr_1_1?dchild=1&keywords=The+Sustainability+Secret%3A+Rethinking+Our+Diet+to+Transform+the+World&qid=1603334870&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "The Ultimate Betrayal: Is There Happy Meat?",
        category: "",
        author: "Hope Bohanec",
        description: "",
        link: "https://www.amazon.com/Ultimate-Betrayal-There-Happy-Meat-ebook/dp/B0792S9D44/ref=sr_1_1?dchild=1&keywords=The+Ultimate+Betrayal%3A+Is+There+Happy+Meat%3F&qid=1603334897&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "The World Peace Diet",
        category: "",
        author: "Will Tuttle",
        description: "",
        link: "https://www.amazon.com/World-Peace-Diet-Spiritual-Harmony/dp/1590565274/ref=sr_1_1?dchild=1&keywords=The+World+Peace+Diet&qid=1603334917&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "This Is Hope: Green Vegans and the New Human Ecology",
        category: "",
        author: "Will Anderson",
        description: "",
        link: "https://www.amazon.com/This-Hope-Green-Vegans-Ecology-ebook/dp/B00AR6LAF6/ref=sr_1_1?dchild=1&keywords=This+Is+Hope%3A+Green+Vegans+and+the+New+Human+Ecology&qid=1603334966&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Turkey Trouble",
        category: "",
        author: "Wendi Silvano, Lee Harper",
        description: "",
        link: "https://www.amazon.com/Turkey-Trouble-Wendi-Silvano/dp/0761455299/ref=sr_1_1?dchild=1&keywords=Turkey+Trouble&qid=1603334996&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Turning Points in Compassion: Personal Journeys of Animal Advocates",
        category: "",
        author: "Gypsy Wulff, Fran Chambers",
        description: "",
        link: "https://www.amazon.com/Turning-Points-Compassion-Personal-Advocates-ebook/dp/B00WR7VVKC/ref=sr_1_1?dchild=1&keywords=Turning+Points+in+Compassion%3A+Personal+Journeys+of+Animal+Advocates&qid=1603335045&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Twas the Night Before Thanksgiving",
        category: "",
        author: "Dave Pilkey",
        description: "",
        link: "https://www.amazon.com/Night-Before-Thanksgiving-Scholastic-Bookshelf/dp/0439669375/ref=sr_1_1?dchild=1&keywords=%27Twas+the+Night+Before+Thanksgiving&qid=1603335071&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Uncooped: Deconstructing the Domesticated Chicken",
        category: "",
        author: "National Museum of Animals & Society",
        description: "",
        link: "https://www.upc-online.org/pp/fall2013/uncooped.html",
        "": "",
    },
    {
        type: "Books",
        name: "V Is for Vegan: The ABCs of Being Kind",
        category: "",
        author: "Ruby Roth",
        description: "",
        link: "https://www.amazon.com/V-Vegan-ABCs-Being-Kind/dp/1583946497/ref=sr_1_1?dchild=1&keywords=V+Is+for+Vegan%3A+The+ABCs+of+Being+Kind&qid=1603335241&sr=8-1",
        "": "",
    },
    {
        type: "Books",
        name: "Vegan Freak: Being Vegan in a Non-Vegan World",
        category: "",
        author: "Bob Torres, Jenna Torres",
        description: "",
        link: "https://www.amazon.com/Vegan-Freak-Being-Non-Vegan-World-ebook/dp/B0010KRPW0/ref=sr_1_fkmr0_1?dchild=1&keywords=vegan+freak%3A+being+vegan+ina+non-vegan+world&qid=1603335431&s=books&sr=1-1-fkmr0",
        "": "",
    },
    {
        type: "Books",
        name: "Vegan Is Love: Having Heart and Taking Action",
        category: "",
        author: "Ruby Roth",
        description: "",
        link: "https://www.amazon.com/Vegan-Love-Having-Taking-Action/dp/1583943544/ref=sr_1_1?dchild=1&keywords=Vegan+Is+Love%3A+Having+Heart+and+Taking+Action&qid=1603335403&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Veganomics: The Surprising Science on What Motivates Vegetarians, from the Breakfast Table to the Bedroom",
        category: "",
        author: "Nick Cooney",
        description: "",
        link: "https://www.amazon.com/Veganomics-Surprising-Motivates-Vegetarians-Breakfast-ebook/dp/B07BT8R435/ref=sr_1_1?dchild=1&keywords=Veganomics%3A+The+Surprising+Science+on+What+Motivates+Vegetarians%2C+from+the+Breakfast+Table+to+the+Bedroom&qid=1603335476&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Vegetarian Judaism: A Guide for Everyone",
        category: "",
        author: "Roberta Kalechofsky",
        description: "",
        link: "https://www.amazon.com/Vegetarian-Judaism-Everyone-Roberta-Kalechofsky/dp/0916288455/ref=sr_1_1?dchild=1&keywords=Vegetarian+Judaism%3A+A+Guide+for+Everyone&qid=1603335493&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "We Animals",
        category: "",
        author: "Jo-Anne McArthur",
        description: "",
        link: "https://www.amazon.com/We-Animals-Jo-Anne-McArthur/dp/1590565460/ref=sr_1_2?dchild=1&keywords=We+animals&qid=1603335514&s=books&sr=1-2",
        "": "",
    },
    {
        type: "Books",
        name: "We're Vegan!",
        category: "",
        author: "Anna Bean",
        description: "",
        link: "https://www.amazon.com/Were-Vegan-Anna-Bean/dp/1494310112/ref=sr_1_3?dchild=1&keywords=We%27re+Vegan%21&qid=1603335539&s=books&sr=1-3",
        "": "",
    },
    {
        type: "Books",
        name: "What a Fish Knows: The Inner Lives of Our Underwater Cousins",
        category: "",
        author: "Jonathan Balcome",
        description: "",
        link: "https://www.amazon.com/What-Fish-Knows-Underwater-Cousins/dp/0374537097/ref=sr_1_1?dchild=1&keywords=What+a+Fish+Knows%3A+The+Inner+Lives+of+Our+Underwater+Cousins&qid=1603335559&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "What the Animals Taught Me: Stories of Love and Healing from a Farm Animal Sanctuary",
        category: "",
        author: "Stephanie Marohn",
        description: "",
        link: "https://www.amazon.com/What-Animals-Taught-Me-Sanctuary/dp/B00DP1WD5Q/ref=sr_1_1?dchild=1&keywords=What+the+Animals+Taught+Me%3A+Stories+of+Love+and+Healing+from+a+Farm+Animal+Sanctuary&qid=1603335575&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "When Vegans (Almost) Rule the World",
        category: "",
        author: "Marla Rose",
        description: "",
        link: "https://www.amazon.com/When-Vegans-Almost-Rule-World/dp/1490462295/ref=sr_1_1?dchild=1&keywords=when+vegan+%28almost%29+rule+the+world&qid=1603335622&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Who Cares About Animal Rights? (One World)",
        category: "",
        author: "Michael Twinn",
        description: "",
        link: "https://www.amazon.com/Cares-About-Animal-Rights-World/dp/0859533581",
        "": "",
    },
    {
        type: "Books",
        name: "Whole: Rethinking the Science of Nutrition",
        category: "",
        author: "T. Colin Campbell, Howard Jacobson",
        description: "",
        link: "https://www.amazon.com/Whole-Rethinking-Nutrition-Colin-Campbell/dp/1939529840/ref=sr_1_1?dchild=1&keywords=Whole%3A+Rethinking+the+Science+of+Nutrition&qid=1603335707&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Why I Will ALWAYS Be Vegan:125 Essays from Around the World",
        category: "",
        author: "Butterflies Katz",
        description: "",
        link: "https://www.amazon.com/Why-will-ALWAYS-vegan-essays/dp/1512067806/ref=sr_1_1?dchild=1&keywords=Why+I+Will+ALWAYS+Be+Vegan%3A125+Essays+from+Around+the+World&qid=1603335729&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Why We Love Dogs, Eat Pigs, and Wear Cows:An Introduction to Carnism",
        category: "",
        author: "Melanie Joy",
        description: "",
        link: "https://www.amazon.com/Love-Dogs-Pigs-Wear-Cows/dp/1590035011/ref=sr_1_1?dchild=1&keywords=Why+We+Love+Dogs%2C+Eat+Pigs%2C+and+Wear+Cows%3AAn+Introduction+to+Carnism&qid=1603335749&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Why Animal Suffering Matters:Philosophy, theology, and practical ethics",
        category: "",
        author: "Andrew Linzey",
        description: "",
        link: "https://www.amazon.com/Why-Animal-Suffering-Matters-Philosophy/dp/0195379772/ref=sr_1_1?dchild=1&keywords=Why+Animal+Suffering+Matters%3APhilosophy%2C+theology%2C+and+practical+ethics&qid=1603335772&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Why Animals Matter:The case for animal protection",
        category: "",
        author: "Erin E. Williams, Margo DeMello",
        description: "",
        link: "https://www.amazon.ca/Why-Animals-Matter-Animal-Protection/dp/1591025230",
        "": "",
    },
    {
        type: "Books",
        name: "Why Animals Matter: Animal consciousness, animal welfare, and human well-being",
        category: "",
        author: "Marian Stamp",
        description: "",
        link: "https://www.amazon.com/Why-Animals-Matter-Consciousness-Well-being/dp/0199747512/ref=sr_1_1?dchild=1&keywords=Why+Animals+Matter%3A+Animal+consciousness%2C+animal+welfare%2C+and+human+well-being&qid=1603335859&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Will Travel for Vegan Food: A Young Woman's Solo Van-Dwelling Mission to Break Free, Find Food, and Make Love",
        category: "",
        author: "Kristin Lajeunesse, Jacki Graziano",
        description: "",
        link: "https://www.amazon.com/Will-Travel-Vegan-Food-Van-Dwelling-ebook/dp/B00VSC9Q5E/ref=sr_1_1?dchild=1&keywords=Will+Travel+for+Vegan+Food%3A+A+Young+Woman%27s+Solo+Van-Dwelling+Mission+to+Break+Free%2C+Find+Food%2C+and+Make+Love&qid=1603335893&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "With the Eyes of Love: Dispatches from the Front Line",
        category: "",
        author: "Christa Blanke",
        description: "",
        link: "https://books.google.co.id/books/about/With_the_Eyes_of_Love.html?id=iE2YMwEACAAJ&redir_esc=y",
        "": "",
    },
    {
        type: "Books",
        name: "Women and the Animal Rights Movement",
        category: "",
        author: "Emily Gaarder",
        description: "",
        link: "https://www.amazon.com/Women-Animal-Rights-Movement-Gaarder-ebook/dp/B007IEBDWU/ref=sr_1_1?dchild=1&keywords=Women+and+the+Animal+Rights+Movement&qid=1603335974&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Meat Logic: Why Do We Eat Animals?",
        category: "",
        author: "Charles Horn",
        description: "",
        link: "https://www.amazon.com/Meat-Logic-Why-Eat-Animals/dp/1499379242",
        "": "",
    },
    {
        type: "Books",
        name: "A Plea for the Animals",
        category: "",
        author: "Matthieu Ricard",
        description: "",
        link: "https://www.amazon.com/Plea-Animals-Philosophical-Evolutionary-Imperative/dp/1611804744/ref=sr_1_1?dchild=1&keywords=A+Plea+for+the+Animals&qid=1603336136&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "Our Animal Neighbors: Compassion for Every Furry, Slimy, Prickly Creature on Earth",
        category: "",
        author: "Matthieu Ricard, Jason Gruhl , Becca Hall",
        description: "",
        link: "https://www.amazon.com/Our-Animal-Neighbors-Compassion-Creature/dp/1611807239/ref=sr_1_1?dchild=1&keywords=Our+Animal+Neighbors%3A+Compassion+for+Every+Furry%2C+Slimy%2C+Prickly+Creature+on+Earth&qid=1603336170&s=books&sr=1-1",
        "": "",
    },
    {
        type: "Books",
        name: "OBLIVIOUS: A Vegan Memoir",
        category: "",
        author: "Sande Nosonowitz",
        description: "",
        link: "https://www.amazon.com/OBLIVIOUS-Vegan-Memoir-Sande-Nosonowitz/dp/1096389193/ref=sr_1_fkmrnull_1?crid=2PQOVW6O2086U&keywords=oblivious+a+vegan+memoir&qid=1557856417&s=books&sprefix=OBLIVIOUS%2Caps%2C130&sr=1-1-fkmrnull",
        "": "",
    },
    {
        type: "Books",
        name: "Beyond Beliefs: A Guide to Improving Relationships and Communication for Vegans, Vegetarians, and Meat Eaters",
        category: "",
        author: "Melanie Joy",
        description: "",
        link: "https://www.amazon.com/Beyond-Beliefs-Relationships-Communication-Vegetarians/dp/1944903305",
        "": "",
    },
    {
        type: "Books",
        name: "The Vegan Matrix: Understanding and Discussing Privilege Among Vegans to Build a More Inclusive and Empowered Movement",
        category: "",
        author: "Melanie Joy",
        description: "",
        link: "https://www.amazon.com/Vegan-Matrix-Understanding-Discussing-Privilege/dp/1590566173",
        "": "",
    },
    {
        type: "Books",
        name: "Vystopia: The Anguish of Being Vegan in a Non-vegan World",
        category: "",
        author: "Clare Mann",
        description: "",
        link: "https://www.amazon.com/Vystopia-anguish-being-vegan-non-vegan-ebook/dp/B07DHK9P5K",
        "": "",
    },
    {
        type: "Books",
        name: "We All Love: A Book for Compassionate Little Vegans and Vegetarians",
        category: "",
        author: "Julie Hausen",
        description: "",
        link: "https://www.amazon.com/We-All-Love-Compassionate-Vegetarians/dp/069298786X?crid=152D4XL0I5KTD&dchild=1&keywords=we+all+love&qid=1624465046&s=books&sprefix=we+all+love%2Caps%2C198&sr=1-1&linkCode=ll1&tag=sailsandtails-20&linkId=ad1746b32bb40eb9a859980a08265984&language=en_US&ref_=as_li_ss_tl",
        "": "",
    },
    {
        type: "Books",
        name: "Eat & Run: My Unlikely Journey to Ultramarathon Greatness",
        category: "",
        author: "Scott Jurek",
        description: "",
        link: "https://www.amazon.com/Eat-Run-Unlikely-Ultramarathon-Greatness/dp/1408833409/ref=tmm_pap_swatch_0?_encoding=UTF8&sr=8-11",
        "": "",
    },

]
